module.exports = __webpack_public_path__ + "img/echo.4b9ebf2a.jpg";